<div
  id="step-connecting-systems"
  class="flex h-full min-h-0 flex-col overflow-hidden"
>
  <div class="flex-shrink-0">
    <div class="space-y-2">
      <h2 class="fdk-type-heading-2 text-fdk-primary">
        Choose your health systems
      </h2>
      <p class="fdk-type-paragraph text-fdk-secondary">
        Select the providers you'd like to connect your records from.
      </p>
    </div>
  </div>

  <div class="flex flex-1 min-h-0 flex-col gap-6 pt-6 overflow-hidden">
    <div
      id="connecting-systems-list"
      class="flex flex-1 min-h-0 flex-col overflow-hidden"
    >
      <!-- Empty Account Result Alert -->
      <div *ngIf="emptyTefcaRLSResult" class="mt-fdk-xl" role="alert">
        <div class="text-center"><fdk-illustration name="empty" /></div>
        <h3 class="fdk-type-heading-3 text-fdk-primary text-center mt-fdk-m">
          No providers found
        </h3>
        <p class="fdk-type-paragraph text-fdk-secondary mt-fdk-xxs text-center">
          <ng-container *ngIf="(configService.systemConfigSubject | async)?.tefcaMode">
            We couldn't automatically find providers linked to your details.
          </ng-container>
          You can search for and add them manually.
        </p>
      </div>

      <div
        id="account-cards"
        class="flex min-h-0 flex-col gap-fdk-xxs overflow-y-auto no-scrollbar"
      >
        <ng-container
          *ngIf="configService.vaultProfileConfigSubject | async as vaultProfile"
        >
          <fdk-checkbox
            *ngIf="hasSelectableAccounts(vaultProfile)"
            id="select-all-accounts"
            class="flex-shrink-0"
            value="select-all"
            [checked]="areAllAccountsSelected(vaultProfile)"
            [indeterminate]="areSomeAccountsSelected(vaultProfile)"
            (change)="
              toggleAllAccounts($any($event.target).checked, vaultProfile)
            "
          >
            Select all
          </fdk-checkbox>
        </ng-container>

        <!-- connected accounts -->
        <fdk-card
        *ngFor="
          let connectedAccount of sortAccountsByName((
            configService.vaultProfileConfigSubject | async
          )?.connectedPatientAccounts)
        "
        class="connected-account-card flex-shrink-0"
        [title]="
          connectedAccount.portal?.name || connectedAccount.brand?.name || ''
        "
        [initials]="
          getAccountInitials(
            connectedAccount.portal?.name || connectedAccount.brand?.name || ''
          )
        "
        [logo]="getAccountLogo(connectedAccount.brand?.id)"
        variant="select"
        [selected]="true"
        (click)="
          deselectTefcaDirectAccount(
            connectedAccount.vault_profile_connection_id
          )
        "
        />

        <!-- discovered accounts -->
        <fdk-card
        *ngFor="
          let discoveredAccount of (
            configService.vaultProfileConfigSubject | async
          )?.discoveredPatientAccounts || {} | keyvalue: compareAccountEntriesByName
        "
        class="discovered-account-card flex-shrink-0"
        [title]="
          discoveredAccount.value.portal?.name ||
          discoveredAccount.value.brand?.name ||
          ''
        "
        [initials]="
          getAccountInitials(
            discoveredAccount.value.portal?.name ||
              discoveredAccount.value.brand?.name ||
              ''
          )
        "
        [logo]="getAccountLogo(discoveredAccount.value.brand?.id)"
        variant="select"
        (click)="
          connectTefcaDirectAccount(
            discoveredAccount.key,
            discoveredAccount.value
          )
        "
        />

        <!-- pending accounts -->
        <fdk-card
        *ngFor="
          let pendingAccount of (
            configService.vaultProfileConfigSubject | async
          )?.pendingPatientAccounts || {} | keyvalue: compareAccountEntriesByName
        "
        class="pending-account-card flex-shrink-0"
        [title]="
          pendingAccount.value.portal?.name ||
          pendingAccount.value.brand?.name ||
          ''
        "
        [initials]="
          getAccountInitials(
            pendingAccount.value.portal?.name ||
              pendingAccount.value.brand?.name ||
              ''
          )
        "
        [logo]="getAccountLogo(pendingAccount.value.brand?.id)"
        variant="signIn"
        (click)="connectAccount(pendingAccount.key, pendingAccount.value)"
        />
      </div>

      <fdk-button
        id="search-button"
        class="mt-fdk-m flex-shrink-0"
        width="full"
        type="button"
        variant="secondary"
        [routerLink]="'/search'"
      >
        <span class="flex items-center justify-center gap-2">
          <fdk-icon name="plus" [size]="24" />
          Add another health system
        </span>
      </fdk-button>
    </div>
  </div>

  <div class="dashboard-footer mt-auto mt-fdk-xxs space-y-4 flex-shrink-0">
    <fdk-button
      id="connecting-continue"
      type="button"
      variant="primary"
      width="full"
      [disabled]="
        !(
          (configService.vaultProfileConfigSubject | async)
            ?.connectedPatientAccounts || []
        ).length
      "
      (click)="confirmAccounts()"
    >
      Connect selected providers
    </fdk-button>
  </div>
</div>
